import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'site-react/core/Icon/MaterialIcon';
import { css, cx } from 'emotion';
import guidesLinks from '../data/guides';
import {
  GuidesContainer,
  GuidesLeftColumn,
  GuidesRightColumn,
  Title,
  TitleTopMarginModifier,
  List,
  ListItem,
  Image,
  ImageContainer,
  TextContainer,
  GuidesTextWidthModifierLeft,
  GuidesTextWidthModifierRight,
  TextLink,
  SeeMoreLink,
} from './DesktopNavPanelStyles';

const { helpGuides, learnMore, aboutHubble } = guidesLinks;
const DesktopNavPanelGuides = ({ clickHandler, linkTarget }) => (
  <div className={GuidesContainer}>
    <div className={GuidesLeftColumn}>
      <div className={Title}>{helpGuides.title}</div>
      <ul className={List}>
        {helpGuides.links.map((link, index) => (
          <li className={ListItem} key={`${link.name}-${index + 1}`}>
            <div className={ImageContainer}>
              <a
                href={link.url}
                onClick={(event) =>
                  clickHandler(event, {
                    analytics: helpGuides.analytics,
                    ...link,
                  })
                }
              >
                <img
                  className={Image}
                  src={`https://hubble.imgix.net/site/navigation/${link.imagePath}?fit=crop&w=56&h=56&auto=compress`}
                  alt={link.label}
                />
              </a>
            </div>
            <div className={cx(TextContainer, GuidesTextWidthModifierLeft)}>
              <a
                className={TextLink}
                href={link.url}
                target={linkTarget}
                onClick={(event) =>
                  clickHandler(event, {
                    analytics: helpGuides.analytics,
                    ...link,
                  })
                }
              >
                {link.label}
              </a>
            </div>
          </li>
        ))}
        {
          // NOTE: we use a lot of superfluous brand primary colour here because
          // of how the older styled-components CSS for other parts of the
          // meganav override the CSS work here
          // TODO: refactor this to use fewer superfluous additional colour rules
          // when the rest of the meganav styling has been refactored
          // (see anchor tag below with SeeMoreLink and also inline CSS)
        }
        <li
          className={cx(
            ListItem,
            css`
              margin-bottom: 16px;
            `,
          )}
        >
          <a href={helpGuides.more.url} className={cx(TextLink, SeeMoreLink)}>
            {helpGuides.more.label}
            <MaterialIcon
              className={css`
                vertical-align: middle;
              `}
              iconType="keyboard_arrow_right"
            />
          </a>
        </li>
      </ul>
    </div>
    <div className={GuidesRightColumn}>
      <div className={Title}>{learnMore.title}</div>
      <ul className={List}>
        {learnMore.links.map((link, index) => (
          <li className={ListItem} key={`${link.name}-${index + 1}`}>
            <div className={cx(TextContainer, GuidesTextWidthModifierRight)}>
              <a
                className={TextLink}
                href={link.url}
                onClick={(event) =>
                  clickHandler(event, {
                    analytics: learnMore.analytics,
                    ...link,
                  })
                }
              >
                {link.label}
              </a>
            </div>
          </li>
        ))}
      </ul>
      <div className={cx(Title, TitleTopMarginModifier)}>
        {aboutHubble.title}
      </div>
      <ul className={List}>
        {aboutHubble.links.map((link, index) => (
          <li className={ListItem} key={`${link.name}-${index + 1}`}>
            <div className={cx(TextContainer, GuidesTextWidthModifierRight)}>
              <a
                className={TextLink}
                href={link.url}
                onClick={(event) =>
                  clickHandler(event, {
                    analytics: aboutHubble.analytics,
                    ...link,
                  })
                }
              >
                {link.label}
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

DesktopNavPanelGuides.defaultProps = {
  clickHandler: null,
  linkTarget: '_self',
};

DesktopNavPanelGuides.propTypes = {
  clickHandler: PropTypes.func,
  linkTarget: PropTypes.string,
};

export { DesktopNavPanelGuides };
export default DesktopNavPanelGuides;
